import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { tests } from "../util/consts";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const getFilterLabel = (type, value) => {
  const parsedValue = JSON.parse(value);

  switch (type) {
    case "days":
      return parsedValue.join(", ");
    case "time":
      return parsedValue.replace("to", " ~ ");
    case "radius":
      return parsedValue + " mi";
    case "tests":
      const labels = parsedValue.map((value) => {
        const test = tests.find((obj) => obj.name === value);
        return test.label;
      });
      return labels.join(", ");
  }
};

const FiltersChipArray = () => {
  const [chipData, setChipData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const tagsArray = Array.from(searchParams.entries()).filter((tag) => {
      return (
        tag[0] === "days" ||
        tag[0] === "time" ||
        tag[0] === "radius" ||
        tag[0] === "tests"
      );
    });
    const tagsObjectArray = tagsArray.map((tag) => ({
      key: tag[0],
      label: getFilterLabel(tag[0], tag[1]),
    }));
    setChipData(tagsObjectArray);
  }, [searchParams]);

  const handleDelete = (chipToDelete) => () => {
    searchParams.delete(chipToDelete.key);
    setSearchParams(searchParams);

    setChipData((chips) =>
      chips.filter((chip) => chip.key !== chipToDelete.key)
    );
  };

  if (chipData.length > 0) {
    return (
      <Paper
        sx={{
          display: "flex",
          // justifyContent: "center",
          flexWrap: "wrap",
          listStyle: "none",
          p: 0.5,
          m: 0,
        }}
        component="ul"
      >
        {chipData.map((data) => {
          return (
            <ListItem key={data.key}>
              <Chip label={data.label} onDelete={handleDelete(data)} />
            </ListItem>
          );
        })}
      </Paper>
    );
  }
  return null;
};

export default FiltersChipArray;
